import { useTranslation } from 'react-i18next'
import type { ECurrency } from '../../../types/enums'
import { trpc } from '../../../utils'
import { Avatar } from '../../atoms'
import { Money } from '../../molecules'
import {
  columnsStyle,
  contentStyle,
  drawerContainer,
  headerStyle,
  nameColumn,
  rakeContainer,
} from './index.css'

export const TableMenuLeaderboard = (props: {
  tableId: string
  currency?: ECurrency
}) => {
  const { data: leaders } = trpc.leaderboard.getLeaderboard.useQuery({
    tableId: props.tableId,
  })
  const { t } = useTranslation()

  return (
    <div className={drawerContainer}>
      {leaders?.rake && leaders.rake > 0 ? (
        <div className={rakeContainer}>
          <span>
            {t('modal.leaderboard.label.rake')}: {leaders.rake}
          </span>
        </div>
      ) : null}
      <div className={headerStyle}>
        <span>{t('modal.leaderboard.column.name')}</span>
        <span>{t('modal.leaderboard.column.buyIn')}</span>
        <span>{t('modal.leaderboard.column.result')}</span>
      </div>
      <div className={contentStyle}>
        {leaders
          ? leaders.players.map((player) => (
              <div
                key={player.id}
                className={columnsStyle}
              >
                <div className={nameColumn}>
                  <Avatar
                    avatar={player.avatar || null}
                    faceDirection='right'
                  />
                  <span>{player.name}</span>
                </div>
                <span>
                  {player.buyIn ? (
                    <Money
                      withIcon={true}
                      iconFirst={true}
                      currency={props.currency}
                    >
                      {player.buyIn}
                    </Money>
                  ) : (
                    '—'
                  )}
                </span>
                <span>
                  {player.result > 0 ? `+${player.result}` : player.result}
                </span>
              </div>
            ))
          : null}
      </div>
    </div>
  )
}
